import 'index.scss';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from 'components/home/App';
// import AuthProvider from 'components/auth/AuthProvider';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import { Fragment } from 'react';
import { HashRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
// import { authDomains } from 'types/dev';
import { version } from '../package.json';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      cacheTime: 60000,
    },
  },
});

// const enableAuth = authDomains.some((authDomain) => authDomain.domain === window.location.hostname);

root.render(
  <Fragment>
    <div hidden>{`version: ${version}`}</div>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          {/* <AuthProvider enabled={enableAuth}> */}
          <App />
          {/* </AuthProvider> */}
        </HashRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </Fragment>,
);
